import { render } from "./HousingDetail.vue?vue&type=template&id=af6059b4&scoped=true"
import script from "./HousingDetail.vue?vue&type=script&lang=js"
export * from "./HousingDetail.vue?vue&type=script&lang=js"

import "./HousingDetail.vue?vue&type=style&index=0&id=af6059b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af6059b4"]])

export default __exports__